import Provider from './provider';
import "./src/assets/styles/scaffolding.scss";

export const wrapRootElement = Provider;
